import { axiosInstance } from '../config';
import { getUserSession, getHeaders } from '../authentication';

export const getCompanyNamesByKey = (key) => {
  const config = getHeaders(getUserSession());
  return axiosInstance.get('companyNamesView/byKey/' + key,config);
};

export const getCompanyNameByName = (name) => {
  const config = getHeaders(getUserSession());
  return axiosInstance.get('companyNamesView/byName/' + name,config);
};

